import { Time } from "@angular/common";

export const dateTimeFromTimeString = (date: Date, time: string): Date => {
  // expected format for time is 24H as: HH:MM
  let hours = Number(time.match(/^(\d+)/)[1]);
  const minutes = Number(time.match(/:(\d+)/)[1]);
  const AMPM = time.match(/\s(.*)$/)[1];
  if (AMPM === "PM" && hours < 12) {
    hours = hours + 12;
  }
  if (AMPM === "AM" && hours === 12) {
    hours = hours - 12;
  }
  let sHours = hours.toString();
  let sMinutes = minutes.toString();
  if (hours < 10) {
    sHours = "0" + sHours;
  }
  if (minutes < 10) {
    sMinutes = "0" + sMinutes;
  }

  const _time: Time = {
    hours: +sHours,
    minutes: +sMinutes,
  };

  const dateTime: Date = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    _time.hours,
    _time.minutes
  );
  return dateTime;
};

export const shortDateFormat = "MM/dd/yyyy";
export const shortDateTimeFormat = "MM/dd/yyyy hh:mm a";
export const shortDateTimeWithSecondsFormat = "MM/dd/yyyy hh:mm:ss a";
export const shortDateTimeFormatWithDash = "M-dd-yyyy hh:mm a";
export const longDateFormat = "MMMM d, yyyy";
export const formDateFormat = "yyyy-MM-dd";

/**
 * Converts a UTC date to a local date object that displays correctly in datepicker
 * This prevents timezone conversion issues where UTC dates appear as previous day
 */
export const convertUtcToLocalDate = (utcDate: Date): Date | null => {
  if (!utcDate) return null;
  
  // Create a new date using the UTC year, month, and day as local values
  const date = new Date(utcDate);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};